import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";

export const useConnectedInterventionIdToFilter = () => useTypedQuery({ queryKey: AppointmentDetailsKeys.connectedInterventionIdToFilter, initialData: null }).data;

export const setConnectedInterventionIdToFilter = (id: number | null) => typedQueryClient.setQueryData(AppointmentDetailsKeys.connectedInterventionIdToFilter, id);
